export default "__VITE_ASSET__C_Us7fNF__"